import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sanjiao",
  "use": "icon-sanjiao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sanjiao\"><defs><style></style></defs><path d=\"M270.387 27.273L754.62 512.495 269.398 996.728z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol